
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import UserLocationsMultiselect from '@/components/autocompleteMultiselects/UserLocationsMultiselect.vue';
import TitlesMultiselect from '@/components/autocompleteMultiselects/TitlesMultiselect.vue';
import ProjectsMultiselect from '@/components/autocompleteMultiselects/ProjectsMultiselect.vue';
import FiltersContainer from '@/components/filters/filters-container.vue';
import UiButton from '@/components/button/ui-button.vue';
import FormGroupNew from '@/components/form/FormGroupNew.vue';
import ProfileCountrySelect from '@/components/autocompleteMultiselects/ProfileCountrySelect.vue';
import UserCityMultiselect from '@/components/autocompleteMultiselects/UserCityMultiselect.vue';

import DropdownOption from '@/entities/DropdownOption';
import ManagersCollectionFiltersQuery from '@/entities/filters/ManagersCollectionFiltersQuery';

import getMultiselectValues from '@/helpers/multiselect/getMultiselectValues';
import RegionInput from '@/components/autocompleteMultiselects/RegionInput.vue';

@Component({
	components: {
		RegionInput,
		UserLocationsMultiselect,
		TitlesMultiselect,
		ProjectsMultiselect,
		UiButton,
		FiltersContainer,
		FormGroupNew,
		UserCityMultiselect,
		ProfileCountrySelect,
	},
})
export default class ManagerSearchFilters extends Vue {
	@Prop({ type: Object, required: true })
	readonly filters!: ManagersCollectionFiltersQuery;
	@Prop({ type: Boolean, required: true }) readonly getRoleAdmin!: boolean;

	countries: DropdownOption[] = [];
	states: DropdownOption[] = [];
	cities: DropdownOption[] = [];
	titles: DropdownOption[] = [];
	skillsIds: number[] = [];
	projectsIds: string[] = [];
	name: string = this.filters.name;

	get countriesNames(): string[] {
		return this.countries.map((country) => country.name);
	}

	get statesNames(): string[] {
		return this.states.map((state) => state.name);
	}

	get citiesNames(): string[] {
		return this.cities.map((city) => city.name);
	}

	get titlesNames(): string[] {
		return this.titles.map((title) => title.name);
	}

	get propToWatch(): string {
		return JSON.stringify([
			this.name,
			this.countriesNames,
			this.statesNames,
			this.citiesNames,
			this.titlesNames,
			this.skillsIds,
			this.projectsIds,
		]);
	}

	@Watch('filters', { immediate: true })
	updateFiltersValues(): void {
		this.countries = getMultiselectValues(this.filters.countries);
		this.states = getMultiselectValues(this.filters.states);
		this.cities = getMultiselectValues(this.filters.cities);
		this.titles = getMultiselectValues(this.filters.titles);
		this.skillsIds = this.filters.skills;
		this.projectsIds = this.filters.projects;
		this.name = this.filters.name;
	}

	@Watch('propToWatch')
	handlePropToWatchChange(): void {
		this.$emit('filtersChanged', {
			name: this.name,
			countries: this.countriesNames,
			states: this.statesNames,
			cities: this.citiesNames,
			titles: this.titlesNames,
			skills: this.skillsIds,
			projects: this.projectsIds,
		});
	}

	handleReset(): void {
		this.$emit('filtersReset');
	}
}
